import React from 'react';
import { useNavigate } from 'react-router-dom';
import mainPageImg from '../images/mainpageimg.jpg';
import { FaMobileAlt, FaClock, FaUsers } from 'react-icons/fa';

function Main({ scrollToMoreDetails }) {
    const navigate = useNavigate();

    const goToStartNow = () => {
        navigate('/startNow');
    };

    return (
        <div className="flex justify-center w-screen font-raleway">
            <div className="flex flex-col md:flex-row max-w-7xl w-full">

                {/* LEFT - Content */}
                <div className="flex md:w-1/2">
                    <div className="m-5 md:m-10 w-full">

                        {/* Title */}
                        <p className="mt-16 text-xl font-bold md:text-3xl">
                            Aplicativo AiGarçom
                        </p>
                        <div className="mt-2">
                            <p className="text-lg md:text-lg text-gray-700 leading-relaxed">
                                <span className="font-bold text-gray-900">AiGarçom</span> é uma solução completa para seu restaurante.
                            </p>
                        </div>
                        <p className="mt-5 text-lg md:text-lg text-gray-600 leading-relaxed">
                            Melhore a experiência dos seus clientes, agilize o atendimento
                            e aumente o faturamento do seu negócio.
                        </p>

                        {/* Main Feature */}
                        <div className="flex items-start gap-4 mt-5">
                            <FaMobileAlt className="text-orange-500 text-2xl mt-1 shrink-0" />

                            <div>
                                <h2 className="text-xl font-bold text-gray-800">
                                    Solução Completa + Autoatendimento
                                </h2>

                                <p className="mt-1 text-lg md:text-lg text-gray-700">
                                    O cliente faz o próprio pedido pelo celular.
                                </p>
                            </div>
                        </div>

                        {/* Benefits */}
                        <div className="mt-3 space-y-5">

                            {/* Reduce waiting time */}
                            <div className="flex items-center gap-2">
                                <div className="flex items-center justify-center w-7 h-7 rounded-full bg-orange-100 shrink-0">
                                    <FaClock className="text-orange-500 text-xl" />
                                </div>

                                <p className="text-lg md:text-lg text-gray-700">
                                    <span className="font-bold">
                                        Reduz o tempo de espera
                                    </span>
                                    , proporcionando mais agilidade no atendimento.
                                </p>
                            </div>

                            {/* Improve productivity */}
                            <div className="flex items-center gap-2">
                                <div className="flex items-center justify-center w-7 h-7 rounded-full bg-orange-100 shrink-0">
                                    <FaUsers className="text-orange-500 text-xl" />
                                </div>

                                <p className="text-lg md:text-lg text-gray-700">
                                    <span className="font-bold">
                                        Melhora a produtividade da equipe
                                    </span>
                                    , permitindo que seus atendentes se concentrem
                                    no que realmente importa:{' '}
                                    <span className="font-bold text-gray-900">
                                        atender bem.
                                    </span>
                                </p>
                            </div>

                        </div>

                        {/* Download message */}
                        <p className="mt-8 text-left text-gray-700 text-lg md:text-xl">
                            Baixe o aplicativo AiGarçom
                        </p>

                        <p className="text-left text-gray-700 text-lg md:text-xl">
                            é fácil e rápido!
                        </p>

                        {/* Buttons */}
                        <div className="flex flex-col sm:flex-row gap-4 mt-8">

                            <button
                                onClick={goToStartNow}
                                className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-6 rounded transition"
                            >
                                Comece grátis!
                            </button>

                            <button
                                onClick={scrollToMoreDetails}
                                className="bg-white border border-blue-500 text-blue-500 hover:bg-blue-50 font-bold py-2 px-6 rounded transition"
                            >
                                Mais informações
                            </button>

                        </div>

                    </div>
                </div>

                {/* RIGHT - Image */}
                <div className="flex md:w-1/2 justify-center items-center">
                    <img
                        src={mainPageImg}
                        alt="AiGarçom aplicativo"
                        className="p-2 md:p-5 w-full md:w-3/4 h-auto object-contain"
                    />
                </div>

            </div>
        </div>
    );
}

export default Main;
